import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Get share token from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const shareToken = urlParams.get('share_token');

    if (shareToken) {
      request = request.clone({
        setHeaders: {
          'Share-Token': shareToken,
        },
      });
    } else {
      // Regular JWT auth flow
      const jwtToken = this.authService.getToken();
      if (jwtToken) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
      }
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.authService.logout();
          return EMPTY;
        }
        return throwError(err);
      }),
    );
  }
}
